import { render, staticRenderFns } from "./IconDrag.vue?vue&type=template&id=0a465654&"
import script from "./IconDrag.vue?vue&type=script&lang=js&"
export * from "./IconDrag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports